import e, { useState as d, useRef as J, useMemo as k, useEffect as H } from "react";
import L from "./index79.mjs";
import { Guests as X } from "./index80.mjs";
import { DatesContainer as Z } from "./index81.mjs";
import { Button as ee } from "./index82.mjs";
import { isValidQueryValues as te } from "./index83.mjs";
import { getQueryParams as oe } from "./index84.mjs";
import r from "./index85.mjs";
import re from "./index86.mjs";
import { DATES_GUESTS_HASH as ae } from "./index87.mjs";
import { useTracking as se } from "./index88.mjs";
import { Header as ne } from "./index89.mjs";
import { Toast as ie, ToastState as le } from "./index90.mjs";
import { useSearch as me } from "./index91.mjs";
import { track as O } from "./index9.mjs";
import { TRACK_EVENT_TYPE as U, TRACK_EVENT as x } from "./index10.mjs";
import { getConfigPropertyAtomCreator as G, ConfigProperty as F, ViewLayout as A } from "./index13.mjs";
import { isDatePickerPageAtom as ce } from "./index58.mjs";
import { promoCodeAtom as $ } from "./index26.mjs";
import { useAtomValue as N, useSetAtom as de } from "jotai";
import { setQueryParams as pe } from "./index92.mjs";
import { formatDateISO8601 as p } from "@amenitiz/design-system";
import { useHotelConfig as ue } from "./index93.mjs";
import { getSubscriptionPlanRoot as v } from "./index14.mjs";
import fe from "classnames";
import { CollapsibleContainer as Ee } from "./index94.mjs";
import { ValidateCode as he } from "./index95.mjs";
import { GiftCardCarousel as _e } from "./index96.mjs";
const Ce = ({
  arrivalDate: a,
  departureDate: s,
  totalAdults: u,
  totalChildren: n,
  promoCode: i
}) => {
  const f = pe({
    start_date: p(a),
    end_date: p(s),
    adults: u.toString(),
    children: n.toString(),
    promoCode: i
  }), { origin: E, pathname: l } = window.location;
  history.pushState({}, "", `${E}${l}${f}`);
}, ge = () => {
  const a = N($);
  return /* @__PURE__ */ e.createElement(
    Ee,
    {
      title: I18n.t("booking_engine.information.promo_code.title"),
      icon: /* @__PURE__ */ e.createElement(re, { "data-testid": "icon-promo-code" }),
      subtitle: a
    },
    /* @__PURE__ */ e.createElement(
      he,
      {
        codeAtom: $,
        validateCode: (s) => L.validatePromoCode(s),
        customClasses: r["promo-code"],
        showHint: !0
      }
    )
  );
}, We = ({ onClose: a, onSearchClick: s }) => {
  se(ae);
  const [u, n] = d(!1), {
    setGiftCardCurrency: i,
    giftCardCurrency: f,
    setSearchResults: E,
    searchInputs: l,
    isCompleteSearch: R
  } = me(), [P, B] = d(!0), [z, h] = d(!1), [_, K] = d(), T = J(null), M = N(
    k(
      () => G(F.HAS_PROMOCODE_ENABLED),
      []
    )
  ), { hotelId: I, hotelName: Q, propertySize: D, propertyType: C, subscriptionPlan: g } = ue(), q = de(ce), y = N(
    k(() => G(F.VIEW_LAYOUT), [])
  );
  H(() => {
    async function t() {
      const o = await L.getGiftCards();
      K(o.gift_cards), i(o.currency);
    }
    t();
  }, [i]), H(() => {
    h(!1);
  }, [l]);
  const w = () => {
    var t;
    h(!0), (t = T.current) == null || t.scrollIntoView({ behavior: "smooth" });
  }, W = async () => {
    if (!R)
      return;
    n(!0), q(!0);
    const {
      arrivalDate: t,
      departureDate: o,
      totalAdults: m,
      totalChildren: c,
      promoCode: S = ""
    } = l;
    O(x.CLICK, U.SEARCH_COMPLETED, {
      hotel_id: I,
      property_type: C,
      property_size: D,
      subscription_plan: v(g),
      search_data: {
        total_adults: m,
        total_children: c,
        total_guests: m + c,
        selected_date_range: `${p(
          t
        )} - ${p(o)}`,
        promo_code_added: !!S
      }
    });
    try {
      const b = await L.getRoomAvailability(
        t,
        o,
        m,
        c,
        S
      );
      b.rooms.length ? (Ce({
        arrivalDate: t,
        departureDate: o,
        totalAdults: m,
        totalChildren: c,
        promoCode: S
      }), E(b), s()) : (O(x.VIEW, U.NO_RESULTS_AVAILABLE, {
        hotel_id: I,
        property_type: C,
        property_size: D,
        subscription_plan: v(g),
        search_data: {
          property_type: C,
          subscription_plan: v(g)
        }
      }), w()), n(!1);
    } catch {
      w(), n(!1);
    }
  }, V = oe(window.location.search), Y = () => /* @__PURE__ */ e.createElement("div", { className: r["search-button"] }, /* @__PURE__ */ e.createElement(
    ee,
    {
      type: "submit",
      label: I18n.t("booking_engine.search.submit"),
      disabled: u || !R,
      onClick: W
    }
  )), j = () => /* @__PURE__ */ e.createElement("div", { className: r.footer, "data-testid": "search-footer" }, Y(), _ && _.length > 0 ? /* @__PURE__ */ e.createElement("div", { className: r["gift-cards"] }, /* @__PURE__ */ e.createElement(_e, { giftCards: _, currency: f })) : null);
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: fe(r.search, {
        [r["search--full-screen"]]: y === A.FULL_SCREEN
      }),
      "data-testid": "search"
    },
    /* @__PURE__ */ e.createElement(
      ne,
      {
        title: I18n.t("booking_engine.search.header"),
        onClose: a,
        isFullScreenLayout: y === A.FULL_SCREEN
      }
    ),
    y === A.FULL_SCREEN ? /* @__PURE__ */ e.createElement("div", { "data-testid": "hotel-name", className: r.hotel_name }, Q) : null,
    te(V) ? /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", null, "Search with this values"), /* @__PURE__ */ e.createElement("div", null, Object.entries(V).map(([t, o]) => /* @__PURE__ */ e.createElement("div", { key: t }, t, ": ", o)))) : /* @__PURE__ */ e.createElement("div", { className: r.content }, /* @__PURE__ */ e.createElement(
      Z,
      {
        expand: P,
        setExpand: B
      }
    ), /* @__PURE__ */ e.createElement(X, { expand: !P }), M === "true" ? /* @__PURE__ */ e.createElement(ge, null) : null),
    z ? /* @__PURE__ */ e.createElement(
      ie,
      {
        index: 0,
        message: I18n.t("booking_engine.search.no_results.title"),
        state: le.NEUTRAL,
        onClose: () => h(!1)
      }
    ) : null,
    j(),
    /* @__PURE__ */ e.createElement("div", { ref: T })
  );
};
export {
  We as Search
};
